'use strict';

$(window).load(function () {
    function ReloadCards() {
        var $container = $('.cards__wrapper_club'), $stamp = $container.find('.card-club').not(':visible');
    }

    $('[js-card-price-callback]').on('click', function () {
        var $this = $(this),
            $modal = $($this.data('modal'));
        $modal.find('[name=_target]').val($this.data('target'));
        $modal.find('#card-name').html($this.data('title'));
        $$.openModal($modal);
    });


    var filters = {},
        $filters = $('[js-card-filter] input[type=checkbox],[js-card-filter] input[type=ratio]'),
        $filtered_content = $('[js-card-filter-content]'),
        $cards = $filtered_content.find('.card-club');

    function cardFilters() {
        var count = Object.keys( filters ).length;
        $cards.removeClass('visible');
        if (count < 1) {
            $filtered_content.removeClass('filtered-on');

        } else {
            $filtered_content.addClass('filtered-on');
            $cards.each(function () {
                var $this = $(this),
                    check = true,
                    card_count = 0;
                for (var filter_class in filters) {
                    if (!$this.hasClass('card-club_filter-' + filter_class)) {
                        check = false;
                    }
                }
                if (check){
                    $this.addClass('visible');
                    card_count ++;
                }
                if(card_count<1){
                    $filtered_content.addClass('filtered_not-found');
                }else{
                    $filtered_content.removeClass('filtered_not-found');
                }
            });
        }
        ReloadCards();
    }

    function clearFilters() {
        $.each(filters, function (index, value) {
            delete filters[index];
            $filtered_content.removeClass(value)
        });
        $filters.prop('checked', false).trigger('change');
    }

    $filters.on('change', function () {
        var $this = $(this);
        if ($this.prop("checked")) {
            filters[$this.attr('id')] = 'filtered-' + $this.val();
            var $group = $filters.filter('[data-group=' + $this.data('group') + ']').filter('[id!="' + $this.attr('id') + '"]');
            $group.prop("checked", false);
            $group.each(function () {
                delete filters[$(this).attr('id')];
            });
            $this.prop("checked", true);
        } else {
            $filtered_content.removeClass('filtered-' + $this.val());
            delete filters[$this.attr('id')];
        }
        cardFilters();
        ReloadCards()
    });
    $('[js-card-filter-clear]').on('click', function () {
        clearFilters();
        ReloadCards()
    });
});